<template>
  <div class="body-wrap">

    <div itemscope itemtype="https://schema.org/Restaurant" style="display: none;" v-if="currentCity">
      <span itemprop="name">Краснодарский парень</span>
      <span itemprop="servesCuisine">Fast Food, Burgers, Russian</span>
      <span itemprop="priceRange">₽</span>
      <span itemprop="telephone">{{ currentCity?.configs?.telephone }}</span>
      <span itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
            <span itemprop="streetAddress">{{ currentCity?.configs?.config_address }}</span>
            <span itemprop="addressLocality">{{ currentCity?.name }}</span>
            <span itemprop="addressRegion">RU</span>
            <span itemprop="postalCode">00000</span>
            <span itemprop="addressCountry">RU</span>
        </span>
    </div>

    <DisclaimerBar v-if="currentCity?.on_testing"/>
    <TheLoader v-show="mainLoader"/>
    <TheHeader/>

    <div class="container" v-if="isProfilePage">
      <TheProfileTab/>
    </div>

    <router-view v-slot="{ Component }"  :key="$route.fullPath">
      <transition name="scale" mode="out-in" >
        <component :is="Component"/>
      </transition>
    </router-view>

    <TheFooter/>
<!--    <TheCityQuestionModal v-if="showCityQuestionModal"/>-->
    <TheCityModal v-if="showCityModal"/>
    <TheShippingModal v-if="showShippingModal"/>
    <TheLoginModal v-if="showLoginModal"/>
    <KpProfileModal v-if="isShowProfileModal" />
    <TheProductModal/>
    <!-- <OnlyOnClient>
      <TheModalDepartmentNowIsStop/>
    </OnlyOnClient> -->
    <SvgPack/>
    <CookiesWindow />
    <OnlyOnClient>
      <ComboWidget />
    </OnlyOnClient>
    <AppModal />
    <OnlyOnClient>
      <MessageModal />
    </OnlyOnClient>
    <!-- <MessageModal /> -->
  </div>
</template>

<script>

import TheLoader from "@/components/TheLoader.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import SvgPack from "@/components/SvgPack.vue";
import OnlyOnClient from "@/components/OnlyOnClient.vue";
import TheCityModal from "@/components/element/TheCityModal.vue";
import TheHeader from "@/components/element/TheHeader.vue";
import TheLoginModal from "@/components/element/TheLoginModal.vue";
import KpProfileModal from "@/components/element/ProfileModal.vue";
import TheFooter from "@/components/element/TheFooter.vue";
import TheShippingModal from "@/components/element/TheShippingModal.vue";
import TheProductModal from "@/components/element/TheProductModal.vue";
import TheCategoryList from "@/components/element/TheCategoryList.vue";
import TheProfileTab from "@/components/element/TheProfileTab.vue";
import TheModalDepartmentNowIsStop from "@/components/element/TheModalDepartmentNowIsStop.vue";
import CookiesWindow from '@/components/element/CookiesWindow.vue'
import DisclaimerBar from "@/components/DisclaimerBar.vue";
import ComboWidget from "@/components/element/ComboWidget.vue";
import AppModal from '@/components/element/modals/AppModal.vue'
import MessageModal from '@/components/element/MessageModal.vue'

export default {
  name: 'App',
  components: {
    DisclaimerBar,
    TheModalDepartmentNowIsStop,
    TheProfileTab,
    TheCategoryList, TheProductModal,
    TheShippingModal,
    TheFooter,
    TheLoginModal,
    KpProfileModal,
    TheHeader,
    TheCityModal,
    OnlyOnClient,
    SvgPack,
    TheLoader,
    CookiesWindow,
    ComboWidget,
    AppModal,
    MessageModal
  },
  computed: {
    ...mapGetters('profileModal', ['isShowProfileModal']),
    ...mapState({
      mainLoader: state => state.mainLoader,
      showCityQuestionModal: state => state.city.showCityQuestionModal,
      showCityModal: state => state.city.showCityModal,
      currentCity: state => state.city.currentCity,
      showShippingModal: state => state.shipping.showModal,
      showLoginModal: state => state.showLoginModal,
      metaInfo: state => state.meta,
      shipping: state => state.shipping.shipping,
      reward: state => state.reward.applied,
      coupon: state => state.coupon.coupon,
    }),
    isProfilePage(){
      const profilePages = ['profile:personal', 'profile:history', 'profile:rewards', 'profile:addresses'];
      return profilePages.includes(this.$route.name);
    }
  },
  data() {
    return {
      callbackShippingChangeTimeout: null,
    }
  },
  async asyncData({store}) {

  },
  watch: {
    'shipping.modal_info': {
      handler(newVal, oldVal) {
        if(newVal && (newVal.title !== oldVal?.title && newVal.content !== oldVal?.content)) {
          this.$messageModal.show({
            title: newVal.title,
            content: newVal.content
          })
        }
      },
      immediate: true
    },
    shipping(newVal, oldVal ){
      clearTimeout(this.callbackShippingChangeTimeout);
      this.callbackShippingChangeTimeout = setTimeout(this.callbackShippingChange, 1500, newVal, oldVal)
    },
    metaInfo: {
      handler() {
        this.$store.dispatch('updateMeta');
      },
      deep: true
    },
  },
  created() {
    this.$store.dispatch('updateMeta');
  },

  methods: {
    ...mapActions('profileModal', ['setShowProfileModal']),
    callbackShippingChange(newVal, oldVal){
      if(newVal?.institution?.institution_id !== oldVal?.institution?.institution_id){
        this.$store.dispatch('catalog/load');
        this.$store.dispatch('cart/load');
        this.$store.dispatch('payment/loadList');
      }
    }
  }
}
</script>


<style scoped>

.scale-enter-active,
.scale-leave-active {
  transition: all 300ms ease;
  position: relative; /* Добавляем позиционирование, чтобы псевдоэлементы работали корректно */
}

.scale-enter-from,
.scale-leave-to {
  opacity: 0;
  transform: scale(0.99);
}

</style>
